import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT_MEMBER',
  REMOVE: 'REMOVE_PROJECT_MEMBER',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT_INSPECTION',
};

export const removeMember = (projectId, memberId) => {
  return {
    type: ACTION.REMOVE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_MEMBERS}remove/`,
      data: {
        project_id: projectId,
        member_id: memberId,
      },
    })
      .then(() => ({ id: memberId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const listProjectMember = (pageSize, page, sorted, filtered, project_id) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_MEMBERS,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sorted => sorted.desc ? `-${sorted.id}` : sorted.id ).join(',')
          : null,
        project_id,
      },
    }),
  };
};


// WEBPACK FOOTER //
// ./src/redux/project_member/project_member_actions.js